import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchSite } from "@/lib/api";
import { SITE_URL } from "@/lib/seo";

export const useSite = () => useQuery({ queryKey: ["site"], queryFn: fetchSite });

function upsertMeta(attr, key, content) {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  document.querySelectorAll('script[data-seo="page"]').forEach((n) => n.remove());
  (data || []).forEach((item) => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo", "page");
    el.textContent = JSON.stringify(item);
    document.head.appendChild(el);
  });
}

export function usePageMeta({ title, description, path = "/", image, robots, jsonLd, verification }) {
  const jsonLdKey = JSON.stringify(jsonLd || []);
  useEffect(() => {
    if (title) document.title = title;
    const url = `${SITE_URL}${path}`;
    const img = `${SITE_URL}${image || "/assets/img/og-image.jpg"}`;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots || "index, follow");
    upsertLink("canonical", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);
    if (verification) upsertMeta("name", "google-site-verification", verification);
    setJsonLd(jsonLd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, robots, jsonLdKey, verification]);
}
